import React from "react";
import { useTranslation } from "react-i18next";
import color from "../../../Constants/colors";
import { VoicesCampaignStatus } from "../../../Enums/voices";
import { VoicesStatusTag } from "../Common/VoicesFilterParts";

interface Props {
  status: VoicesCampaignStatus;
}

const VoicesCampaignStatusChip: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation("voicesCampaigns");
  const active = status === VoicesCampaignStatus.ACTIVE;

  return (
    <VoicesStatusTag
      label={active ? t("statusActive") : t("statusClosed")}
      tone={active ? color.green700 : color.gray600}
    />
  );
};

export default VoicesCampaignStatusChip;
